import axios from "axios";

export default {
  methods: {
    gp_getSessionKey() {
      let sessionKey;
      if (this.$router.currentRoute.name == "GiftCardAdd")
        sessionKey = this.$store.getters.serviceSessionKey;
      else
        sessionKey = this.$store.state.store.sessionKey;

      return sessionKey;
    },

    gp_getStorageKey() {
      let storageKey;
      if (this.$router.currentRoute.name == "GiftCardAdd") storageKey = this.$store.getters.memberCompanyCode;
      else storageKey = this.$store.getters.storeCompanyCode;

      let phoneNo = "";
      if (this.$store.state.member != null) phoneNo = this.$store.state.member.PhoneId;
      else phoneNo = this.$store.state.guest.phone1;
      if (phoneNo != "") storageKey += "_" + phoneNo;

      console.log("sp_getStorageKey", storageKey);
      return storageKey;
    },    

    gp_getRequest(payload) {
      let jreq = {
        sessionId: this.$store.state.appSessionID,
        sessionKey: this.gp_getSessionKey(),
        data: payload,
      };
      let request = JSON.stringify(jreq);
      console.log(request);

      return axios
        .post(this.$store.state.gpApiUrl + "getgprequest", request, this.$store.state.httpReqOpt)
        .then((result) => result.data)
        .then((data) => {
          console.log(data);
          return data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gp_getStatus(orderId) {
      let jreq = {
        sessionId: this.$store.state.appSessionID,
        sessionKey: this.gp_getSessionKey(),
        data: { order_id: orderId },
      };
      let request = JSON.stringify(jreq);

      return axios
        .post(this.$store.state.gpApiUrl + "getgpstatus", request, this.$store.state.httpReqOpt)
        .then((result) => result.data)
        .then((data) => {
          console.log(data);
          return data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gp_setPayerId(payerId) {
      if (this.$idb == null) return false;  
      
      let that = this;
      return new Promise(function(resolve) {
        let key = "GP_PID_" + that.gp_getStorageKey();
        that.$idb.setting
          .put({ name: key, value: payerId })
          .then(() => {
            resolve(true);
          })
          .catch((error) => {
            console.log("gp setPayerId catched", error);
            resolve(false);
          });
      });
    },

    gp_getPayerId() {
      if (this.$idb == null) return "";   

      let that = this;
      return new Promise(function(resolve) {
        let key = "GP_PID_" + that.gp_getStorageKey();
        that.$idb.setting
          .get(key)
          .then((record) => resolve(record.value))
          .catch(() => resolve(""));
      });
    },

    gp_setPayerId_v1(payerId) {
      let key = "GP_PID_" + this.gp_getStorageKey();
      localStorage.setItem(key, payerId);
    },

    gp_getPayerId_v1() {
      let gpPayerID = "";
      let key = "GP_PID_" + this.gp_getStorageKey();
      if (localStorage.getItem(key)) {
        gpPayerID = localStorage.getItem(key);
      }

      return gpPayerID;
    },    
  },
};
